module.exports = __webpack_public_path__ + "img/ai-summary.44e58c5d.png";